"use client"

import { FC } from "react"
import SelectRangeDateSkeleton from "./SelectRangeDate.skeleton"

type SelectCheckInOutSkeletonProps = {
  size?: "small" | "default"
}

const SelectCheckInOutSkeleton: FC<SelectCheckInOutSkeletonProps> = ({ size = 'default' }) => {

  return (
    <SelectRangeDateSkeleton
      size={size}
    />
  )
}

export default SelectCheckInOutSkeleton